import moment from 'moment/moment';
import { i18n } from '@/i18n';

export default {
  namespaced: true,
  state: {
    receiptInfo: {},
    receipts: [],
    transactionDetails: {},
  },
  getters: {
    getReceiptInfo(state) {
      return state.receiptInfo;
    },
    getReceipts(state) {
      return state.receipts;
    },
    getTransactionDetails(state) {
      return state.transactionDetails;
    },
  },
  mutations: {
    setReceiptInfo(state, payload) {
      state.receiptInfo = payload;
    },
    setReceipts(state) {
      state.receiptInfo.paymentResps.forEach((receipt) => {
        const receiptData = {};

        receiptData.orderUuid = receipt.orderUuid;
        receiptData.amount = receipt.totalAmount;
        receiptData.category = receipt.orderDetails.categoryName;
        receiptData.product = receipt.orderDetails.productName;
        receiptData.status = receipt.orderStatus;
        receiptData.isLoading = false;

        state.receipts.push(receiptData);
      });
    },
    setTransactionDetails(state) {
      const details = {};
      // #TODO make this a global helper to use through project
      let amount = state.receiptInfo.paymentResps.reduce((accumulator, receipt) => accumulator + receipt.amount, 0);
      const amountInArray = String(amount).split('.');

      if (amountInArray[1] && amountInArray[1].length > 2) {
        amount = `${amountInArray[0]}.${amountInArray[1].slice(0, 2)}`;
      }

      details.date = moment(state.receiptInfo.paymentResps[0].orderDate).format('DD.MM.YYYY, HH:mm');
      details.category = i18n.t('misc.fav.debt_payment_category');
      details.amount = `${amount} ${i18n.t('misc.transfer.confirm.amount.currency')}`;
      details.commission = `${state.receiptInfo.commission} ${i18n.t('misc.transfer.confirm.amount.currency')}`;
      details.totalAmount = `${state.receiptInfo.totalAmount} ${i18n.t('misc.transfer.confirm.amount.currency')}`;
      details.source = state.receiptInfo.paymentType;

      state.transactionDetails = details;
    },
    clearReceiptInfo(state) {
      state.receiptInfo = {};
      state.receipts = [];
      state.transactionDetails = {};
    },
  },
};
